import type { ReactElement, ReactNode } from 'react';
import { MermaidDiagram } from './mermaid-diagram.js';

// react-markdown components that draw ```mermaid blocks, for the Markdown views without their own code renderer

function isMermaid(className?: string): boolean {
  return className?.split(' ').includes('language-mermaid') ?? false;
}

export const mermaidComponents = {
  pre({ children }: { children?: ReactNode }) {
    const child = children as ReactElement<{ className?: string }> | undefined;
    // A diagram is not preformatted text: no <pre> around it
    if (child?.props && isMermaid(child.props.className)) return <>{children}</>;
    return <pre>{children}</pre>;
  },
  code({ className, children }: { className?: string; children?: ReactNode }) {
    if (isMermaid(className)) return <MermaidDiagram code={String(children ?? '').replace(/\n$/, '')} />;
    return <code className={className}>{children}</code>;
  },
};
